// extracted by mini-css-extract-plugin
export default {"switchContainer":"time-slot-table_switchContainer__CVhpc"};